export const MESSAGES = {
  NO_DATA: "경기 시작 전 입니다.",
};
